<template>
    <div class="wave-background d-flex justify-content-center align-items-center">
        <div class="login-sequence-box text-center card"
            :class="[$breakpoint.xsOnly ? 'p-4' : 'p-5']"
        >
            <img :src="logoUrl" alt="Online Fuels Logo" class="d-block mb-5 logo" />
            <form class="login w-100">
                <h1 class="heading-medium">You have been successfully logged out</h1>
                <h2 class="heading-medium">Have a great {{time | timecategory}}</h2>
                <i class="fas fa-check-circle fa-4x text-t_green mx-auto d-block my-5"></i> 
                <router-link :to="{'name': 'Login'}" class="btn btn-confirm">
                    Log back in?
                </router-link>
            </form>
        </div>
    </div>
</template>

<script>
import breakpoint from '@/mixins/index';
const platform = process.env.VUE_APP_Platform ?? "DTN"
export default {
    mixins: [breakpoint],
    data(){
        return {
            logoUrl: `/assets/${platform}_Logo.png`,
            time: new Date()
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pages/_logins.scss";
</style>